import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { routes } from "../routes";
import Profile from "./profile";
import Company from "./company";
import Preferences from "./preferences/preferences";
import { Row, Col } from "reactstrap";
import PermissionRoute from "../../components/hoc/PermissionRoute";
import { USER_ROLES } from "../../interfaces/roles";
import Billing from "./billing";
import Insights from "../admin/insightAdmin";
import Tabs from "../../components/tab";

const AccountRouter: React.FC = () => (
	<Row className="account">
		<Col xs="12" sm="12" md="12" lg="12" xl="12">
			<div className="pt-4">
				<Tabs
					tabs={[
						{
							name: "Profile Settings",
							route: routes.PROFILE
						},
						{
							name: "Company Settings",
							route: routes.COMPANY,
							tabRoles: [USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]
						},
						{
							name: "Preferences",
							route: routes.PREFERENCES,
							tabRoles: [USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]
						},
						{
							name: "Billing",
							route: routes.BILLING,
							tabRoles: [USER_ROLES.COMPANY_ADMIN]
						}
					]}
				/>
				<Switch>
					<Route exact path={routes.PROFILE} component={Profile} />
					<PermissionRoute
						exact
						path={routes.PREFERENCES}
						component={Preferences}
						componentRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]}
					/>
					<PermissionRoute
						path={routes.BILLING}
						component={Billing}
						componentRoles={[USER_ROLES.COMPANY_ADMIN]}
						accessingAccount={true}
					/>
					<PermissionRoute
						exact
						path={routes.COMPANY}
						componentRoles={[USER_ROLES.COMPANY_ADMIN, USER_ROLES.COMPANY_USER]}
						accessingAccount={true}
						component={Company}
					/>
					<PermissionRoute
						path={routes.ADMIN_INSIGHTS}
						component={Insights}
						componentRoles={[USER_ROLES.ADMIN]}
					/>
					<Redirect exact to={routes.PROFILE} from={routes.ACCOUNT} />
				</Switch>
			</div>
		</Col>
	</Row>
);

export default AccountRouter;
